<template>
  <div
    :class="{'has-danger': error}"
    class="form-group row">
    <label
      for="inputPhone"
      class="col-4 col-form-label">Номер телефона <span class="text-danger">*</span></label>
    <div class="col-8">
      <ap-input-phone
        :input-id="'inputPhone'"
        :error="error"
        v-model="phone"
        @input="$emit('input', phone)"/>
    </div>
  </div>
</template>

<script>
import ApInputPhone from '../../../components/ApForm/ApInputPhone'

export default {
  name: 'TcInputPhone',
  props: {
    value: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      phone: this.value
    }
  },
  components: {
    ApInputPhone
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// TcInputPhone.vue?e5313d48